// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from "!mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import { useEffect, useRef, useState } from "react"

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN

export function useMapLoader(mapContainer) {
  const map = useRef()
  const [mapLoaded, setMapLoaded] = useState(false)

  useEffect(() => {
    if (map.current) {
      return
    }
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [-98.02979920000001, 43.7094283],
      zoom: 4.3,
    })
    map.current.on("load", () => {
      setMapLoaded(true)
    })
  })

  return { map, mapLoaded }
}

export function addImageLayerToMap(
  map,
  imageURL,
  imageName,
  sourceName,
  layerID,
  iconSize,
  filter
) {
  map.current.loadImage(imageURL, (error, image) => {
    if (error) {
      throw error
    }
    map.current.addImage(imageName, image)
    map.current.addLayer({
      id: layerID,
      type: "symbol",
      source: sourceName,
      filter,
      layout: {
        "icon-image": imageName,
        "icon-size": iconSize,
      },
    })
  })
}

export function removeSource(mapRef, sourceID) {
  if (mapRef.current.getSource(sourceID)) {
    mapRef.current.removeSource(sourceID)
  }
}

export function removeLayer(mapRef, layerName) {
  if (mapRef.current.getLayer(layerName)) {
    mapRef.current.removeLayer(layerName)
  }
}

export function removeImage(mapRef, imageName) {
  if (mapRef.current.hasImage(imageName)) {
    mapRef.current.removeImage(imageName)
  }
}

export function removeInteraction(mapRef, interactionID) {
  mapRef.current.removeInteraction(interactionID)
}
